/** Dia da semana (0=domingo) de uma data `YYYY-MM-DD`, em UTC para não escorregar de fuso. */
export function weekdayOfDate(date: string): number {
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(date);
  if (!match) throw new Error("invalid_calendar_date");
  return new Date(Date.UTC(Number(match[1]), Number(match[2]) - 1, Number(match[3]))).getUTCDay();
}

/** Dias fixos depois de trocar `out` por `inDay`: a quantidade contratada não muda. */
export function replaceWeekday(fixedWeekdays: number[], out: number, inDay: number): number[] {
  return [...new Set([...fixedWeekdays.filter((day) => day !== out), inDay])].sort((a, b) => a - b);
}
